<div id="backToTop">
    <img src="./assets/images/backToTop.svg" class="img-fluid" alt="backToTop" />
    <p>BACK TO TOP</p>
</div>
<div id="backToHome">
  <a href="{{'/'}}" (click)="callCTBackToHomeEvent('BackToHome Icon'); _sharedService.checkCTALink($event, '/');">
    <img src="./assets/images/backTohome.svg" class="img-fluid" alt="backToHome" />
    <p>HOME</p>
  </a>
</div>